import { Button } from "@atomaro/ui-kit";
import { useApiariesStore } from "entities/apiaries";
import { useCurrentHiveStore } from "entities/currentHive";
import { useHivesStore } from "entities/hives";
import { SharedHive } from "entities/hives/model/types";
import { useUserStore } from "entities/user";
import { FC, useState } from "react";
import { COLORS } from "shared/consts";
import { RentHiveModal } from "widgets/rentHiveModal";

type HiveBodyRentProps = {
  findedShared: SharedHive | null;
  isScreenLg: boolean;
};

export const HiveBodyRent: FC<HiveBodyRentProps> = ({
  findedShared,
  isScreenLg,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [successShare, setSuccessShare] = useState<"success" | "">("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const currentHiveId = useCurrentHiveStore((s) => s.currentHiveId);
  const currentApiaryId = useApiariesStore((s) => s.currentApiaryId);
  const userInfo = useUserStore((s) => s.userInfo);
  const shareHive = useHivesStore((s) => s.shareHive);
  const deShareHive = useHivesStore((s) => s.deShareHive);

  const onShareClick = async () => {
    if (!userInfo || !currentApiaryId || !currentHiveId) return;
    try {
      setIsLoading(true);
      const isShare = await shareHive({
        ecppHiveId: currentHiveId,
        season: 2026, // todo заменить на селект сезонов
        apiaryId: currentApiaryId,
      });
      setIsLoading(false);
      if (isShare) setSuccessShare("success");
    } catch (error) {
      console.error("Ошибка при сдаче улья:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeShareClick = async () => {
    if (!userInfo || !currentApiaryId || !findedShared) return;
    try {
      setIsLoading(true);
      const isDeShared = await deShareHive(findedShared?.id);
      if (isDeShared) setIsOpenModal(false);
    } catch (error) {
      console.error("Ошибка при снятие с аренды  улья:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        colorScheme="neutral"
        style={{
          margin: isScreenLg ? "0 0 0 auto" : "0 auto",
        }}
        label="Сдать в аренду"
        onClick={() => {
          setIsOpenModal(true);
          setSuccessShare("");
        }}
        iconSuffix={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 5.5H11V4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V13H18.5V17C18.5 17.8284 17.8284 18.5 17 18.5H7C6.17157 18.5 5.5 17.8284 5.5 17V7C5.5 6.17157 6.17157 5.5 7 5.5ZM15 5.5L17.4394 5.5L8.96967 13.9697L10.0303 15.0303L18.5 6.56072V9.00001H20V4.75C20 4.33579 19.6642 4.00001 19.25 4L15 4L15 5.5Z"
              fill={COLORS.NEUTRAL.DEFAULT}
            />
          </svg>
        }
      />
      <RentHiveModal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onShare={() => onShareClick()}
        onDelShare={() => onDeShareClick()}
        findedShared={findedShared}
        successShare={successShare}
        isLoading={isLoading}
      />
    </>
  );
};
